import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/PromoPageContainer/PromoPageContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { HighlightedTilesSection } from 'components/no-auth/common/sections/HighlightedTilesSection';
import { ListingTilesSection } from 'components/no-auth/common/sections/ListingTilesSection';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const BusinessAccountPage = (props) => {
    return (
        <PromoPageContainer bgColor={'eggshell02'} noIndent>
            {props.heroTitle && (
                <HeroSection
                    title={props.heroTitle}
                    text={props.heroText}
                    img={props.heroImg}
                    btnVariant="primary"
                    noIconBtn
                    horizontalLayout
                    data={props.heroData}
                    fetchPriorityHigh
                />
            )}
            <ColoredSectionContainer>
                {props.tilesHighlighted && <HighlightedTilesSection data={props.tilesHighlighted} />}
                {props.headline1Title && <HeadingSection title={props.headline1Title} text={props.headline1Text} />}
                {props.cards && <TilesSection lang={props.lang} country={props.country} data={props.cards} loadingLazy />}
                {props.headline2Title && <HeadingSection title={props.headline2Title} text={props.headline2Text} />}
                {props.tilesHighlighted2 && <HighlightedTilesSection data={props.tilesHighlighted2} />}
            </ColoredSectionContainer>
            <ColoredSectionContainer>
                {props.cards2 && <TilesSection lang={props.lang} country={props.country} data={props.cards2} />}
                {props.headline3Title && <HeadingSection title={props.headline3Title} text={props.headline3Text} />}
                {props.team && <ListingTilesSection data={props.team} loadingLazy />}
            </ColoredSectionContainer>
            {props.acquisitionTitle && (
                <ColoredSectionContainer bottomPadding>
                    <HeadingSection
                        title={props.acquisitionTitle}
                        text={props.acquisitionText}
                        btn={props.acquisitionBtn}
                        btnMobile={props.acquisitionBtnMobile}
                        isMobileBtn={props.acquisitionIsMobileBtn}
                        noBottomIndent
                    />
                </ColoredSectionContainer>
            )}
        </PromoPageContainer>
    );
};
const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroImg: state.extra?.strapiApi?.hero_block?.img,
        heroData: state.extra?.strapiApi?.hero_block,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        tilesHighlighted: state.extra?.strapiApi?.tiles_highlighted,
        tilesHighlighted2: state.extra?.strapiApi?.tiles_highlighted2,

        headline2Title: state.extra?.strapiApi?.headline2?.title,
        headline2Text: state.extra?.strapiApi?.headline2?.text,

        cards: state.extra?.strapiApi?.tiles_section,
        cards2: state.extra?.strapiApi?.tiles_section2,

        headline3Title: state.extra?.strapiApi?.headline3?.title,
        headline3Text: state.extra?.strapiApi?.headline3?.text,

        team: state.extra?.strapiApi?.team_section,

        acquisitionTitle: state.extra?.strapiApi?.headline4?.title,
        acquisitionText: state.extra?.strapiApi?.headline4?.text,
        acquisitionBtn: state.extra?.strapiApi?.headline4?.btn,
        acquisitionBtnMobile: state.extra?.strapiApi?.headline4?.btn_mobile,
        acquisitionIsMobileBtn: state.extra?.strapiApi?.headline4?.isMobileBtn,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(BusinessAccountPage));
